import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="container" style={{ textAlign: 'center', padding: '8rem 2rem' }}>
      <div style={{
        fontFamily: 'var(--font-mono)',
        fontSize: '0.7rem',
        letterSpacing: '0.28em',
        color: 'var(--cyan)',
        textTransform: 'uppercase',
        marginBottom: '1rem',
      }}>
        / 404
      </div>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '4rem', letterSpacing: '0.02em' }}>
        Not in the file.
      </h1>
      <p style={{ fontFamily: 'var(--font-serif)', fontSize: '1.2rem', color: 'var(--text-dim)', marginTop: '1rem', marginBottom: '2rem' }}>
        ELARIA couldn't locate that route.
      </p>
      <Link to="/" style={{
        display: 'inline-block',
        padding: '0.85rem 1.5rem',
        background: 'var(--cyan)',
        color: 'var(--navy)',
        fontFamily: 'var(--font-mono)',
        fontSize: '0.8rem',
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        borderRadius: 'var(--radius)',
        fontWeight: 600,
      }}>
        Back to home →
      </Link>
    </section>
  );
}
